import { Space }               from 'antd';
import React                   from 'react';
import PublicLayout            from 'containers/Security/PublicLayout';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import { NavLink }             from 'react-router-dom';

export default class NotFound extends React.PureComponent {
  render() {
    return (
      <PublicLayout>
        <Space direction="vertical" size={16}>
          <h1>
            <FormattedMessageWrapper id="Erreur !" />
          </h1>
          <h2>
            <FormattedMessageWrapper id="Cette page n'existe pas." />
          </h2>
          <NavLink to="/">
            <FormattedMessageWrapper id="Retour" />
          </NavLink>
        </Space>
      </PublicLayout>
    );
  }
}
